import React, { useContext, useState } from 'react';
import {
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';

import {
  Delete,

} from '@material-ui/icons';

import PropTypes from 'prop-types';

import AlertDialog from '../modals/alertDialog';
import SpinnerLoading from '../feedback/spinnerLoading';

import { removeClinician } from '../../utils/comms';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function MemberInfo({ handleFeedback, idEnrolment, carerData }) {
  const sessionContext = useContext(SessionContext);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const deleteMember = async () => {
    setShowLoading(true);
    const response = await removeClinician(idEnrolment, carerData._id, sessionContext.userToken);
    setShowLoading(false);
    if (response.status === 200) { // Tenim llistat
      handleFeedback('success', 'DeleteClinicianFromEnrolmentTeam', true);
    } else if (response === 400) { // Error amb les dades
      console.log('Error 400');
      handleFeedback('error', 'DeleteClinicianFromEnrolmentTeam', false);
    } else { // Login KO. Altres errors
      console.log(response);
      handleFeedback('error', 'DeleteClinicianFromEnrolmentTeam', false);
    }
  };

  const manageDeleteAlertAnswer = (agree) => {
    setShowDeleteAlert(false);
    if (agree) deleteMember();
  };

  return (
    <React.Fragment>
      <SpinnerLoading show={showLoading} />
      <AlertDialog open={showDeleteAlert} handleClose={(agree) => manageDeleteAlertAnswer(agree)} title={translations['_deleteMemberAlertTitle']} message={translations['_deleteMemberAlertMessage']} data={[{ username: carerData.username }]} field='username' />
      <Grid container spacing={2} justify='flex-start' alignItems='center'>
        <Grid item xs={5}>
          <Typography variant='body1' component='span'>{carerData.username}</Typography>
        </Grid>
        <Grid item>
          <Grid container justify='flex-start' direction='row'>
            <Grid item>
              <IconButton onClick={() => setShowDeleteAlert(true)}><Delete /></IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
MemberInfo.propTypes = {
  idEnrolment: PropTypes.string.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  carerData: PropTypes.object.isRequired,
};
